import { useQuery } from '@tanstack/react-query';
import { SitterProfileResponse } from 'happypaws-shared/src/Sitter/models/SitterProfileResponse';
import { api } from '../../services/api';

export const useGetSitterById = (sitterId: string | undefined) => {
  return useQuery({
    queryKey: ['sitter', sitterId],
    queryFn: async () => {
      const response = await api.get<SitterProfileResponse>(`/sitters/${sitterId}`);
      return response.data;
    },
    enabled: !!sitterId,
    staleTime: 5 * 60 * 1000,
  });
};
